import { render, staticRenderFns } from "./DraggableTreeItem.vue?vue&type=template&id=cc2788da&scoped=true&"
import script from "./DraggableTreeItem.vue?vue&type=script&lang=js&"
export * from "./DraggableTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTreeItem.vue?vue&type=style&index=0&id=cc2788da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2788da",
  null
  
)

export default component.exports